module.exports = __webpack_public_path__ + "static/media/planeta-tierra.a488a13c.png";